/**
 * ⟦C57 · lot 5d · A-174⟧ **Les textes du Palmarès, en deux longueurs.**
 *
 * À l'écran : une phrase de 12 mots au plus. Ce qui s'y lisait avant est gardé mot pour mot et vit
 * derrière « 📰 Les dessous ». Pur : pas de DOM ; `palmares-court.test.ts` mesure les textes courts.
 */

/** Sans compte : le palmarès vit sur le serveur. */
export const SANS_COMPTE_COURT = "Le palmarès demande un compte.";
export const SANS_COMPTE_LONG =
  "Le palmarès vit sur le serveur : il lui faut un compte. En bac à sable, ta partie ne quitte jamais ce navigateur — il n'y a donc ni mémorial à relire, ni classement où apparaître.";

/** Un classement vide. */
export function videCourt(mode: "hardcore" | "normal"): string {
  return `Personne n'a encore gravé de victoire en ${mode}.`;
}
export function videLong(mode: "hardcore" | "normal"): string {
  return `${videCourt(mode)} Le classement se remplit au million — la place est libre.`;
}
